import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "30341463-c3a5-4d05-83e8-ba7ea310d29e",
    content: "A = 20 log<sub>10</sub>(kd) - 6 = -33 dB / -13 dB",
    options: {},
  },
  {
    id: "4115a42f-4c85-4207-8b88-42397f84dc68",
    content: "A = 6 - 40 log<sub>10</sub>(kd) = +59 dB / +19 dB",
    options: {},
  },
  {
    id: "217bc4b5-50a6-4c56-8d15-dad0fbe6f960",
    content: "A = 6 - 20 log<sub>10</sub>(kd) = +33 dB / +13 dB",
    options: {},
  },
  {
    id: "c12daac4-c20c-4bdb-b7b0-262e2b2a566d",
    content: "A = 40 log<sub>10</sub>(kd) - 6 = -59 dB / -19 dB",
    options: {},
  },
  {
    id: "f075befb-54ec-4d20-931f-5bf23618f9c3",
    content: "A = -20 log<sub>10</sub>(kd) - 6 = +21 dB / +1 dB",
    options: {},
  },
  {
    id: "4606ce42-9c93-4437-b396-7a9b7e6ad2ca",
    content: "A = 40 log<sub>10</sub>(kd) + 6 = -47 dB / -7 dB",
    options: {},
  },
];

export const task: Task = {
  id: "527ba608-4a8e-4559-b849-e2541f04706a",
  solutionType: "select",
  type: "checkbox",
  options: {
    columns: 2,
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["4115a42f-4c85-4207-8b88-42397f84dc68"],
};
